import { render } from "./TopUploaders.vue?vue&type=template&id=1d38f67c"
import script from "./TopUploaders.vue?vue&type=script&lang=js"
export * from "./TopUploaders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__